import axios, { AxiosRequestConfig } from 'axios'
import { api_reminders_path } from '../routes'

export function createReminder(payload) {
  const options: AxiosRequestConfig = {
    url: api_reminders_path({ format: 'json' }),
    method: 'post',
    responseType: 'json',
    data: payload,
  }
  return axios(options).then(response => response.data)
}
